module.exports = __webpack_public_path__ + "assets/img/3cdaef8d1d305339de6a4067228d6f72.png";